const APP_RELATIVE_PREFIX = '/';
const APP_RELATIVE_BASE = 'https://app.invalid/';
const APP_RELATIVE_ORIGIN = 'https://app.invalid';

/**
 * Parses a root-relative path on this application, such as `/clarity/d/<domainId>/documents?doc=<fileId>`.
 *
 * @param href The authored address.
 * @returns The parsed address on a placeholder origin, or `null` when `href` is not a path on this
 * application's own origin — including `//host/…`, `/\host/…` and `/<tab>/host/…`, which name a host.
 */
export function parseClarityAppRelativeUrl(href: string): URL | null {
	if (!href.startsWith(APP_RELATIVE_PREFIX)) {
		return null;
	}

	const address = URL.parse(href, APP_RELATIVE_BASE);

	return address?.origin === APP_RELATIVE_ORIGIN ? address : null;
}
